import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getRole = createAsyncThunk(
  "admin/role",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/role", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getRoleById = createAsyncThunk(
  "admin/role/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/role/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortRole = createAsyncThunk(
  "admin/role/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/role/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postRole = createAsyncThunk(
  "admin/role/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/role", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "admin/role/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/role/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateRole = createAsyncThunk(
  "admin/role/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/role/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const roleSlice = createSlice({
  name: "Role Store",
  initialState: initialState,
  reducers: {
    addRole(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortRole(state, action) {
      state.data.docs = action.payload;
    },
    deleteRole(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editRole(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getRole.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getRole.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getRole.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getRoleById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getRoleById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getRoleById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortRole.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortRole.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortRole.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postRole.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postRole.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postRole.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteRole.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteRole.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteRole.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateRole.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateRole.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateRole.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const roleActions = roleSlice.actions;

export default roleSlice.reducer;
